import * as yup from "yup";
export const recommendationSchema = yup.object().shape({
  title: yup.string().required("Title is required").min(1).max(255),
});
